import React from 'react';
import { useNavigate } from 'react-router-dom';
import BlockMemoryGrid from 'components/common/block-memory-grid/block-memory-grid';
import InfoCard from 'components/common/info-card/info-card';
import SymmetryGrid from 'components/common/symmetry-grid/symmetry-grid';
import OSpanLetterMemory from '../../ospan/ospan-letter-memory';
import OSpanLetterFlashcard from '../../ospan/ospan-letter-flashcard';
import OSpanMathFlashcard from '../../ospan/ospan-math-flashcard';

export function AssessmentContainer({ children }) {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  return (
    <>
      <div className="container d-none d-md-flex">
        <div className="d-flex justify-content-center align-items-center mx-auto w-75 h-100">{children}</div>
      </div>
      <div className="container d-md-none pb-5">
        <div>
          Take this assessment on a laptop or device with a large screen – the images used for this assessment are not
          mobile-friendly
        </div>
        <div className="d-flex w-100 mx-auto justify-content-center my-5">
          <button onClick={goBack} className="btn-assessment-primary btn btn-primary">
            Back to Assessments
          </button>
        </div>
      </div>
    </>
  );
}

export function StepContainer({ step, capture, moveNext }) {
  switch (step.type) {
    case 'INFO_INPUT': {
      const submit = step.props.isInput ? capture : moveNext;
      return <InfoCard {...step.props} submit={submit} />;
    }
    case 'BLOCK_FLASHCARD': {
      return <BlockMemoryGrid flashcard activeItems={step.props.activeItems} resultsCallback={moveNext} />;
    }
    case 'BLOCK_RECALL': {
      return <BlockMemoryGrid {...step.props} resultsCallback={capture} />;
    }
    case 'SYMMETRY_GRID': {
      return <SymmetryGrid key={Math.random()} {...step.props} recordResult={capture} />;
    }
    case 'LETTER_FLASHCARD': {
      return <OSpanLetterFlashcard letter={step.props.letter} resultsCallback={moveNext} recordResult={moveNext} />;
    }
    case 'MATH_FLASHCARD': {
      return (
        <OSpanMathFlashcard
          problem={step.props.problem}
          solution={step.props.solution}
          isCorrect={step.props.isCorrect}
          displayResult={step.props.displayResult}
          recordResult={moveNext}
        />
      );
    }
    case 'MATH_ANSWER': {
      return (
        <OSpanMathFlashcard
          key={Math.random()}
          solution={step.props.solution}
          isCorrect={step.props.isCorrect}
          displayResult={step.props.displayResult}
          trial={step.props.trial}
          recordResult={capture}
        />
      );
    }
    case 'LETTER_RECALL': {
      return <OSpanLetterMemory {...step.props} resultsCallback={capture} />;
    }
    default:
      return null;
  }
}
